export default "__VITE_ASSET__20d5a978__"